import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Status } from '@xingternal/hops';
import { Headline, BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';

import ERROR_404_IMAGE from './assets/404.svg'; // eslint-disable-line
import ERROR_500_IMAGE from './assets/500.svg'; // eslint-disable-line
import ERROR_503_IMAGE from './assets/503.svg'; // eslint-disable-line

import styles from './PageError.css';

type PageErrorProps = {
  type?: 404 | 500 | 503;
  href?: string; 
  ctaCopyKey?: string;
};

const errors = {
  404: {
    headline: 'EP_404_ERROR',
    subline: 'EP_404_ERROR_SUBLINE',
    image: ERROR_404_IMAGE,
  },
  500: {
    headline: 'EP_500_ERROR',
    subline: 'EP_500_ERROR_SUBLINE',
    image: ERROR_500_IMAGE,
  },
  503: {
    headline: 'EP_503_ERROR',
    subline: 'EP_503_ERROR_SUBLINE',
    image: ERROR_503_IMAGE,
  },
};

const PageError = ({ type = 500, href = '/', ctaCopyKey = 'EP_GO_HOME' }: PageErrorProps) => (
  <div className={styles.wrapper}>
    {type && <Status code={Number(type)} />}
    <img className={styles.image} src={errors[type].image} alt="Error image" />
    <Headline size={'medium'} className={styles.headline}>
      <FormattedMessage
        id={errors[type].headline}
        defaultMessage={errors[type].headline}
      />
    </Headline>

    <BodyCopy size={'xsmall'} noMargin className={styles.text}>
      <FormattedMessage
        id={errors[type].subline}
        defaultMessage={errors[type].subline}
      />
    </BodyCopy>

    <Button
      variant={'secondary'}
      size={'small'}
      href={href}
      className={styles.button}
    >
      <FormattedMessage id={ctaCopyKey} defaultMessage={ctaCopyKey} />
    </Button>
  </div>
);

export default PageError;
